import { cn } from '@/lib/utils'
import type { Money } from '@/types'

interface MoneyDisplayProps {
  money: Money
  className?: string
  colorize?: boolean
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

export function MoneyDisplay({
  money,
  className,
  colorize = false,
  size = 'md',
}: MoneyDisplayProps) {
  const sizeClasses = {
    sm: 'text-[13px]',
    md: 'text-sm',
    lg: 'text-lg',
    xl: 'text-2xl font-semibold',
  }

  return (
    <span
      className={cn(
        'tabular-nums font-medium tracking-tight',
        sizeClasses[size],
        colorize && money.negative && 'text-destructive',
        colorize && !money.negative && 'text-success',
        className
      )}
    >
      {money.formatted}
    </span>
  )
}
